import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service'

@Injectable({
    providedIn: 'root'
})
export class UserAuthGuard implements CanActivate {

    constructor(private authService: AuthService, private router: Router) { }

    canActivate(): boolean {
        if (this.authService.userRole() != 'user') {
            return true;
        } else {
            this.router.navigate(['/home']);
            return false;
        }
    }
}